import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/lang_picker_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e63a6fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dropdownMenu",
  ref: "dropdownMenu",
  class: "dropdown"
}
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "float-left !tw-w-[167px]"
}
const _hoisted_4 = { class: "tw-flex tw-h-[24px] tw-w-[28px]" }
const _hoisted_5 = {
  key: 1,
  class: "!tw-min-w-[167px] tw-h-[24px] tw-flex tw-items-center tw-justify-center"
}
const _hoisted_6 = { class: "float-left flag" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "float-right button-arrow dropdown-button-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_9 = {
  ref: "lang-dropdown-menu",
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "dropdown-item-text-division" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LottieAnimation = _resolveComponent("LottieAnimation")!

  return (_openBlock(), _createElementBlock("div", {
    id: "lang-picker",
    class: _normalizeClass(["lang-picker comp-start", 
      !_ctx.selectedItem || _ctx.selectedItem.id === 'Loading' || null
        ? 'tw-pointer-events-none'
        : ''
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "langButton",
        ref: "langButton",
        class: _normalizeClass(["btn dropdown-button", !_ctx.showIcon ? 'dropdown-border' : 'dropdown-border-open']),
        type: "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "data-display": "static",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuClick && _ctx.onMenuClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.selectedItem || _ctx.selectedItem.id === 'Loading' || null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_LottieAnimation, {
                    ref: "anim",
                    "animation-data": _ctx.getProgressAnimation(),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.getImgUrl(_ctx.selectedItem.id),
                    width: "20"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.dDWidth),
                  class: _normalizeClass(["float-left select-placeholder", _ctx.selectedItem ? '' : 'select-placeholder-default'])
                }, _toDisplayString(_ctx.isMobile ? _ctx.selectedItem["iso_639-1"] : _ctx.selectedItem.native_name), 7),
                _hoisted_8
              ]))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("form", {
          id: 'langScroll' + _ctx.isMobile,
          ref: 'langScroll' + _ctx.isMobile,
          class: "dropdown-scroll"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageList, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.id,
              class: _normalizeClass(["dropdown-item", _ctx.selectedItem.id === item.id ? 'selected-item' : '']),
              href: "javascript:void(0)",
              onClick: ($event: any) => (_ctx.onSelectItem(item))
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.native_name), 1)
            ], 10, _hoisted_11))
          }), 128))
        ], 8, _hoisted_10)
      ], 512)
    ], 512)
  ], 2))
}